/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from "relay-runtime";

import {  } from "relay-runtime";
export type sharedMessageHelpers_expiringPromotion = {
    readonly " $fragmentRefs": FragmentRefs<"expiringPromoMessageHelpers_expiringPromotion">;
    readonly " $refType": "sharedMessageHelpers_expiringPromotion";
};
export type sharedMessageHelpers_expiringPromotion$data = sharedMessageHelpers_expiringPromotion;
export type sharedMessageHelpers_expiringPromotion$key = {
    readonly " $data"?: sharedMessageHelpers_expiringPromotion$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"sharedMessageHelpers_expiringPromotion">;
};



const node: ReaderInlineDataFragment = {
    "kind": "InlineDataFragment",
    "name": "sharedMessageHelpers_expiringPromotion"
} as any;
(node as any).hash = '925f9835008643739f14499a6546d9b2';
export default node;
